






import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import '../assets/Svg.js'

@Component
export default class Icon extends Vue {
  @Prop(String) name?: string;
}
